import { validationMixin } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';
import { ExternalEnum, SocialEnum } from '@enums/route-enum';


export default {
  name: 'landing-footer',
  mixins: [validationMixin],

  data() {
    return {
      email: '',
    };
  },

  validations: {
    email: {
      required,
      email,
    },
  },

  computed: {
    footerData() {
      return {
        title: this.$t('common.footer.broker_associations'),
        subscribe: this.$t('common.footer.subscribe.action'),
        copyright: this.$t('common.footer.copyright'),
        successMessage: this.$t('common.footer.subscribe.success'),
        errorMessage: this.$t('common.footer.subscribe.error'),
        subscribeCallback: this.subscribeToMailchimp,
        validator: this.$v,
        links: [
          ExternalEnum.HOME,
          {
            key: 'how-it-works',
            value: 'How it works',
            href: '#how-it-works',
          },
          {
            key: 'about-us',
            value: 'About us',
            href: '#about-us',
          },
          ExternalEnum.CALCULATORS,
          ExternalEnum.BLOG,
          {
            key: 'contact-us',
            value: 'Contact us',
            href: '#contact-us',
          },
          ExternalEnum.FAQS,
        ],
        legalLinks: [ExternalEnum.TERMS, ExternalEnum.PRIVACY],
        socialLinks: [
          SocialEnum.TWITTER,
          SocialEnum.FACEBOOK,
          SocialEnum.LINKEDIN,
          SocialEnum.YOUTUBE,
        ],
        associations: [
          { src: `${this.$cdnUrl}/images/landing-page/footer_1.png` },
          { src: `${this.$cdnUrl}/images/landing-page/footer_2.png` },
          { src: `${this.$cdnUrl}/images/landing-page/footer_3.png` },
        ],
      };
    },
  },

  methods: {
    subscribeToMailchimp() {
      const endpoint = 'https://loandolphin.us11.list-manage.com/subscribe/post-json';

      return this.$jsonp(endpoint, {
        u: 'f68b372912fc3d3d009b2ac1a',
        id: '0e190fe12f',
        EMAIL: encodeURI(this.email),
        MMERGE7: 'NOPHONE',
        callbackQuery: 'c',
      });
    },
  },
};
